<template>
  <calc-form-card v-model="formCardValue" :optional="optional" :title="title">
    <template #controls>
      <b-switch
        v-model="isMinMaxModeOn"
        v-if="hasMinMaxCfg"
        class="is-label_left u-mr12"
        >Min/Max</b-switch
      >

      <b-switch v-model="isSpanBySpan" class="is-label_left">{{
        $t("Definir valor por vão")
      }}</b-switch>
    </template>

    <template v-if="hasMinMaxCfg">
      <template v-if="isMinMaxModeOn">
        <calc-form-item-generic-load-cfg
          :is-span-by-span="isSpanBySpan"
          :the-case="theCase"
          :the-type="theType"
          limit="min"
          key="min"
        >
          <template #title>
            {{ itemTitle }} ({{ $t("Min") }})
            <app-tooltip class="m-width-m">
              {{
                $t(
                  "Valor característico das cargas permanentes a considerar nas combinações com ação variável base ascendente."
                )
              }}
            </app-tooltip>
          </template>
        </calc-form-item-generic-load-cfg>

        <calc-form-item-generic-load-cfg
          :is-span-by-span="isSpanBySpan"
          :the-case="theCase"
          :the-type="theType"
          limit="max"
          key="max"
        >
          <template #title>
            {{ itemTitle }} ({{ $t("max") }})
            <app-tooltip class="m-width-m">
              {{
                $t(
                  "Valor característico das cargas permanentes a considerar nas combinações com ação variável base descendente."
                )
              }}
            </app-tooltip>
          </template>
        </calc-form-item-generic-load-cfg>

        <AppInfoBlock
          class="invalidMinMaxInfoBlock"
          v-if="!isMinMaxValid"
          type="error"
        >
          {{
            $t(
              "Todos os valores da carga distribuida mínima têm que ser inferiores ou iguais ao correspondente valor da carga distribuida máxima."
            )
          }}
        </AppInfoBlock>
      </template>

      <template v-else>
        <calc-form-item-generic-load-cfg
          :is-span-by-span="isSpanBySpan"
          :the-case="theCase"
          :the-type="theType"
          :title="itemTitle"
          limit="min"
          key="default"
        >
        </calc-form-item-generic-load-cfg>
      </template>
    </template>

    <template v-else>
      <calc-form-item-generic-load-cfg
        :is-span-by-span="isSpanBySpan"
        :the-case="theCase"
        :the-type="theType"
        :title="itemTitle"
      >
      </calc-form-item-generic-load-cfg>
    </template>

    <template slot="illustration">
      <calc-illustration
        :which="illustration"
        :is-span-by-span="isSpanBySpan"
      />
    </template>
  </calc-form-card>
</template>

<script>
import { withoutDuplicates, deepClone } from "@/utils";
import { mapState, mapGetters } from "vuex";
import CalcIllustration from "./CalcIllustration";
import CalcFormCard from "./CalcFormCard";
import CalcFormItemGenericLoadCfg from "./CalcFormItemGenericLoadCfg";
import AppInfoBlock from "@/components/app/InfoBlock";

export default {
  components: {
    AppInfoBlock,
    CalcFormCard,
    CalcIllustration,
    CalcFormItemGenericLoadCfg,
  },

  props: {
    ...CalcFormCard.props,

    itemTitle: {
      type: String,
      default: "Título por definir (prop.itemTitle)",
    },

    theCase: {
      type: String,
      required: true,
    },

    theType: {
      type: String,
      required: true,
    },

    hasMinMaxCfg: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      // isMinMaxModeOn: undefined,
      isSpanBySpan: undefined,
      formCardValue: undefined,
    };
  },

  computed: {
    ...mapState("calculator", ["calculation"]),

    ...mapGetters("calculator", {
      load: "load",
      calculatorIsMinMaxValid: "isMinMaxValid",
      totalSpans: "totalSpans",
    }),

    illustration() {
      if (this.theCase === "wind" && this.theType === "suction") {
        return "windSuction";
      } else {
        return "genericLoad";
      }
    },

    theLoad() {
      return this.hasMinMaxCfg ? null : this.load(this.theCase, this.theType);
    },

    theMinLoad() {
      return this.hasMinMaxCfg
        ? this.load(this.theCase, this.theType, "min")
        : null;
    },

    theMaxLoad() {
      return this.hasMinMaxCfg
        ? this.load(this.theCase, this.theType, "max")
        : null;
    },

    spans() {
      return this.hasMinMaxCfg ? this.theMinLoad.value : this.theLoad.value;
    },

    isMinMaxValid() {
      if (!this.hasMinMaxCfg) {
        return null;
      }

      return this.calculatorIsMinMaxValid(this.theCase, this.theType);

      // if (this.isMinMaxModeOn) {
      // 	return !this.theMinLoad.value.some((minVal, i) => {
      // 		const maxVal = this.theMaxLoad.value[i];
      // 		return minVal > maxVal;
      // 	});
      // }
    },

    isMinMaxModeOn: {
      get() {
        if (!this.hasMinMaxCfg) {
          return null;
        }

        return this.calculation.input.internal.loads[this.theType][this.theCase]
          .isMinMaxModeOn;
      },

      set(val) {
        this.calculation.input.internal.loads[this.theType][
          this.theCase
        ].isMinMaxModeOn = val;
      },
    },
  },

  watch: {
    value: {
      handler(val) {
        this.formCardValue = val;
      },
      immediate: true,
    },

    formCardValue(val) {
      this.$emit("input", val);
    },

    isMinMaxModeOn: function (val) {
      if (this.hasMinMaxCfg) {
        if (val) {
          this.theMaxLoad.value = deepClone(this.theMinLoad.value);
        } else {
          this.theMaxLoad.value = Array(this.totalSpans).fill(0);
        }
      }
    },
  },

  created() {
    // // if it's an array of 0's then minMaxMode is off. otherwise on
    // this.isMinMaxModeOn = this.hasMinMaxCfg
    // 	? //is there more than 1 value ? then it cant be all 0's. minMaxMode is on
    // 	  withoutDuplicates(this.theMaxLoad.value).length > 1 ||
    // 	  //ok. it's just 1 value. lets check to see if it's 0. if it is, then it's definitely off. otherwise on
    // 	  this.theMaxLoad.value[1] !== 0
    // 	: null;

    // this.$watch("isMinMaxModeOn", function(val) {
    // 	if (this.hasMinMaxCfg) {
    // 		if (val) {
    // 			this.theMaxLoad.value = deepClone(this.theMinLoad.value);
    // 		} else {
    // 			this.theMaxLoad.value = Array(this.totalSpans).fill(0);
    // 		}

    // 		this.calculation.internal.loads[this.theCase][
    // 			this.theType
    // 		].isMinMaxModeOn = val;
    // 	}
    // });

    this.isSpanBySpan = withoutDuplicates(this.spans).length !== 1;
  },
};
</script>

<style lang="scss" scoped>
.invalidMinMaxInfoBlock {
  max-width: 733px;
  margin-left: 232px;
}
</style>
